import React from "react";
import moment from "moment";
import { Form } from "antd";
import ExecutorInfo from "./FormSections/ExecutorInfo";
// import MonetizationTemplate from './MonetizationTemplate';
// import Monetization from '../../../Executorship/common/FormSections/Monetization';
// import Vehicle from '../../../Executorship/common/FormSections/Vehicle';
// import PaymentDeadlineInDays from '../../../Executorship/common/FormSections/PaymentDeadlineInDays';

class ExecutorCardInfo extends React.Component {
  render() {
    const {
      form,
      isEditable,
      validateField,
      dadataBankSelected,
      typeForm
    } = this.props;
    return (
      <div className="executor-content card-info">
        <Form layout="inline">
          <div>
            <ExecutorInfo
              form={form}
              disabled={!isEditable}
              validateField={validateField}
              typeForm={typeForm}
              dadataBankSelected={dadataBankSelected}
            />
          </div>
        </Form>
      </div>
    );
  }
}

class ExecutorInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      default: {
        subjectKey: "legal"
      }
    };
    this.defaultProfileData = {};
    this.flagInitEditing = false;
  }
  componentDidMount() {
    this.initEditing();
  }
  componentDidUpdate(prevProps, prevState) {
    this.initEditing();
    //if (this.props.checkFormErrors) {
    //  this.props.checkFormErrors(this.props.name);
    //}
  }
  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  //
  initEditing = () => {
    let { isEditable, data: dataProps, executorId } = this.props;
    if (
      !this.flagInitEditing &&
      isEditable &&
      ((dataProps && executorId > 0) || executorId === 0)
    ) {
      this.flagInitEditing = true;

      let newEditData = {};
      if (dataProps && executorId !== 0) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item]
          };
        });
      }
      // add default value
      Object.keys(this.state.default).forEach(item => {
        if (!newEditData[item]) {
          newEditData[item] = this.state.default[item]
            ? { value: this.state.default[item] }
            : {};
        }
      });
      this.setState({ data: newEditData }, () => {
        // проверить все поля на валидность
        if (this.formRef) {
          this.changeValues(this.formRef.getFieldsValue());
        }
      });
    } else if (!isEditable && this.flagInitEditing) {
      this.flagInitEditing = false;
    }
  };

  handleFieldsChange = values => {
    this.setState(
      state => ({
        data: {
          ...state.data,
          ...values
        }
      }),
      () => {
        this.changeValues(values);
      }
    );
  };

  validateField = nameField => {
    let result =
      this.formRef &&
      this.formRef.isFieldTouched(nameField) &&
      this.formRef.getFieldError(nameField);
    // todo Проверить есть ли в сторе ошибки от сервера
    //let err = 'Уже есть такой пользователь';
    //if(nameField === 'phone')
    return {
      status: result ? "error" : "",
      help: result || ""
    };
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      this.props.updateProgress(values);
    }
  };

  //
  render() {
    const { isEditable } = this.props;
    const data = isEditable
      ? this.state.data
      : this.props.data || this.defaultProfileData;
    return (
      <FormExecutorCard
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
        validateField={this.validateField}
      />
    );
  }
}

const FormExecutorCard = Form.create({
  name: "formExecutorCard",
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        /* todo разобраться с серверыными ошибками*/
        let err = {};
        if (
          props.createErrors &&
          props.createErrors.data &&
          props.createErrors.data[name]
        ) {
          err.errors = [new Error(props.createErrors.data[name])];
        }
        let all = true;
        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            ...(props.isEditable ? err : {}),
            value: props.getValueByFieldName(
              name,
              props.isEditable ? props.data[name].value : props.data[name]
            )
          });
        }
      });
    return obj;
  },
  onValuesChange(props, values) {}
})(ExecutorCardInfo);

export default ExecutorInfoData;
